<template>
  <div class="feedback-success-page">
    <mt-header fixed title="意见反馈" style="background:#ffffff;color:#262626;"></mt-header>

    <div class="feedback-tips">
      <img src="../assets/images/feedback_success@3x.png">
      <p>您提交的内容，我们已经收到</p>
    </div>
    <ul class="more-need">
      <li>
        如有需要，我们可以第一时间联系您？
      </li>
      <li>
        <div class="ok btn" :class="{'active':noneed}" @click="isNeed(true)">好的</div>
        <div class="cancel btn" :class="{'active':!noneed}" @click="isNeed(false)">暂不需要</div>
      </li>
      <li :class="{'close':!noneed}">
        <input type="text" placeholder="请留下您的QQ、邮箱或手机号码" id="contact" v-model="contact">
      </li>
    </ul>

    <div class="complete-btn" @click="feedback">
      完成
    </div>
  </div>

</template>

<script>
import { MessageBox } from 'mint-ui'

export default {
    name:"contact",
    metaInfo: {
        title: '果师兄官网_苹果手机数据恢复|微信聊天记录恢复|电脑数据恢复', // set a title
        meta: [{                 // set meta
          name: 'keyWords',
          content: '果师兄恢复大师,苹果数据恢复软件,手机数据恢复软件,电脑数据恢复'
        },{                 // set meta
          name: 'description',
          content: '果师兄恢复大师为用户提供电脑手机数据恢复服务,主要服务包括微信聊 天记录,短信,备忘录,微信好友添加,照片等苹果手机数据恢复,回收站清空文件恢复,U 盘/硬 盘/SD 卡/储存卡等各类存储设备数据恢复,以及相关的数据迁移、数据删除等指导服务'
        }]
    },
    data(){
      return {
        feedback_id: '',
        valid:false,
        suggestion:"",
        want_contact:true,
        qq:"",
        valid:false,
        noneed: true,
        contact: '',
        nextPath: '',
        routes: ['orderDetail',"service"]
      }
    },
    methods:{
      goBack(){
        if(this.routes.indexOf(this.nextPath)>-1){
          history.go(-1)
        }else {
          this.$router.push({name:'my'})
        }
      },
      isNeed(type){
        this.noneed = type
      },
      feedback(){
        if(this.noneed){
          if(this.contact){
            let vm = this;
            let info = {
              feedback_id: this.feedback_id,
              contact: this.contact,
            };
            this.$store.dispatch("addContact",info).then((res)=>{
              let result = res.data
              if(result.code == 0){
                vm.goBack()
              }
            });
          }else {
            let vm = this
            MessageBox({
              title: '',
              message: '留个我们能联系到您的方式',
              showCancelButton: true,
              confirmButtonText: '好的',
              cancelButtonText: '不用了'
            }).then((res)=>{
              if(res == 'cancel'){
                vm.$router.push({name:'my'})
              }else {
                document.querySelector('#contact').focus()
              }
            })
          }
          
        }else{
            this.goBack()
        }
      }
    },
    created(){
        this.feedback_id = this.$route.query.feedback_id;
        this.nextPath = this.$route.query.nextPath
        if(!this.feedback_id){
          this.$router.push({name:"suggestion"})
        }
    },
    mounted(){
    },
    watch:{
      
    },
    components:{
        MessageBox
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/SuggestionNext.vue